import { REVOKE_TOKEN_URI } from "@/shared/auth/helper/authConstants.helper";
import {
  clearAuthTokensCookie,
  getAuthTokensFromCookie,
} from "@/shared/auth/helper/authTokensCookie.helper";

// The headless revoke token flow is documented here: https://developer.salesforce.com/docs/atlas.en-us.headless_identity.meta/headless_identity/headless_identity_postman_revoketoken.htm
export const logout = async () => {
  const tokens = getAuthTokensFromCookie();

  return new Promise((resolve, reject) => {
    const client = new XMLHttpRequest();
    client.open("POST", REVOKE_TOKEN_URI, true);

    client.setRequestHeader(
      "Content-Type",
      "application/x-www-form-urlencoded",
    );

    const requestBody = `token=${tokens?.accessToken}`;

    client.onloadend = () => {
      if (client.status === 200) {
        clearAuthTokensCookie();
        resolve(undefined);
      } else {
        reject(new Error("Logout failed"));
      }
    };

    client.onerror = () => {
      reject(new Error("Network error during logout"));
    };

    client.send(requestBody);
  });
};
